export default function initHeader() {
    const header = document.querySelector("header.sfi-header");
    if (header) {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                header.classList.add("scrolled");
            } else {
                header.classList.remove("scrolled");
            }
        });
    }
}
